import { Box, Stack } from "@mui/material";
import kathleenH from "../../../assets/home-owner/images/Kathleen H..png";
import sophiaL from "../../../assets/home-owner/images/Sophia L..png";
import marcusR from "../../../assets/home-owner/images/Marcus R..png";
import emilyT from "../../../assets/home-owner/images/Emily T..png";

import { DesignersPersonaCard, DesignersPersonaCardProps } from "./designers-persona-card";

const personaCards: DesignersPersonaCardProps[] = [
  {
    title: "Kathleen H.",
    subtitle: "West Coast Tech Meets Luxury Design",
    age: "57",
    tags: ["6 Years"],
    description:
      "With 25 years in the tech consulting field, Victoria made the bold move to become an interior designer six years ago with a focus on luxury residential projects. Victoria listens to her clients' preferences and applies her years of experience with her understanding of current design trends & access to unique materials and furnishings.\n\n\"My vision is clear—to craft exceptional designs that seamlessly blend beauty and functionality. It is my honor to help people transform their living spaces.\"",
    image: kathleenH,
  },
  {
    title: "Sophia L.",
    subtitle: "The Visionary Trendsetter",
    age: "34",
    tags: ["7 Years"],
    description:
      "Sophia is known for creating bold, modern interiors that are rooted in tradition. One-of-a-kind pieces and antiques, mixed with modern looks and classical art are the hallmarks of her designs. Her approach expertly combines unmatched creativity with strategic solutions. She seamlessly integrates fresh aesthetics with traditional sensibilities, enabling clients to feel rooted and current.\n\n\"I love designing projects that stay rooted in tradition and authenticity yet also apply modern sensibilities!\"",
    image: sophiaL,
  },
  {
    title: "Marcus R.",
    subtitle: "The Functional Perfectionist",
    age: "41",
    tags: ["12 Years"],
    description:
      "With a Master's Degree in Interior Architecture, Marcus takes a meticulous approach to interior design to create functional yet aesthetically refined spaces. His philosophy blends minimalism with luxurious flair, daily practical use while minimizing clutter, and user-centered elegance. He excels at transforming working or living conditions, harmonizing both form and function.\n\n\"My mission is to create spaces that are as beautiful as they are livable.\"",
    image: marcusR,
  },
  {
    title: "Emily T.",
    subtitle: "An Emerging Talent",
    age: "27",
    tags: ["3 Years"],
    description:
      "Emily is an up-and-coming decorator who left her 10-5 job in architecture three years ago to pursue her passion for interiors full time. Currently building her niche in smaller residential projects, she focuses heavily on moderns and sustainable design to establish herself as a trend-forward designer in the millennial and Gen Z markets.",
    image: emilyT,
  },
];

export const DesignersPersonaCards = () => {
  return (
    <div className="site-wrapper">
      <Stack direction="row" spacing={2}>
        {personaCards.map((card) => (
          <DesignersPersonaCard key={card.title} {...card} />
        ))}
      </Stack>
    </div>
  );
};
